import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { useLocation } from "react-router-dom";

import Header from "./header";
import Footer from "./footer";

import "./layout.css";

export default function Layout() {
  const { t } = useTranslation();

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const routes = [
    {
      title: t("home"),
      path: "/",
    },
    {
      title: t("activity"),
      path: "/activity",
    },
    {
      title: t("payment"),
      path: "/payment",
    },
    {
      title: t("aboutUs"),
      path: "/about-us",
    },
    {
      title: t("supportUs"),
      path: "/support-us",
    },
    {
      title: t("featured"),
      path: "/featured",
    },
    {
      title: t("academy"),
      path: "/academy",
    },
    {
      title: t("contactUs"),
      path: "/contact-us",
      highlight: true,
    },
  ];

  return (
    <div className="user-layout">
      <div className="user-header">
        <Header routes={routes} />
      </div>

      <div className="user-main">
        <Outlet />
      </div>

      <div className="user-footer">
        <Footer routes={routes} />
      </div>
    </div>
  );
}
